export enum NotificationType {
  JobProgressNotification = 'JobProgressNotification',
  JobResultNotification = 'JobResultNotification',
}
